module.exports = __webpack_public_path__ + "img/galaxyCollide.a2518751.jpg";